import type { OwnerNotificationType } from '@/constants/schema-constants'

export class OwnerNotificationPinningBuildingsGetRequest {
  ownerNotificationTypes!: OwnerNotificationType[]
  scheduledPostDateTime?: string
  ownerNotificationId?: string
}

export class OwnerNotificationPinningBuildingsGetResponse {
  buildingIds: string[] = []
}
